import { createSelector } from "@reduxjs/toolkit";

export const selectCommonAuthState = (state) => state.authState;

export const getAuthState = createSelector(selectCommonAuthState,(authState) => authState.commonAuth.auth);
export const getTokenState = createSelector(selectCommonAuthState,(authState) => authState.commonAuth.tokenState);
export const getGenerateTOTPState = createSelector(selectCommonAuthState,(authState) => authState.commonAuth.generateTOTPState);
